export const breakpoints = [
  '1600px',
];

export const breakpointsToArrayIndex = {
  _: 0,
  xl: 1,
};
